// import {FC} from 'react'

// const Error404: FC = () => {
//   return (
//     <>
//       <h1 className='fw-bolder fs-4x text-gray-700 mb-10'>Page Not Found</h1>

//       <div className='fw-bold fs-3 text-gray-400 mb-15'>
//         The page you looked not found! <br /> Plan your blog post by choosing a topic
//       </div>
//     </>
//   )
// }

// export {Error404}

import {FC} from 'react'
import {Result, Button} from 'antd'
import {useNavigate} from 'react-router-dom'

const Error404: FC = () => {
  const navigate = useNavigate()

  return (
    <div className='flex items-center justify-center h-screen bg-gray-50'>
      <Result
        status='404'
        title='404'
        subTitle='Sorry, the page you visited does not exist.'
        extra={
          <Button type='primary' onClick={() => navigate('/')}>
            Back Home
          </Button>
        }
      />
    </div>
  )
}

export {Error404}
